import { createApp } from 'vue';
import App from './App.vue';
import { CIcon } from '@coreui/icons-vue';
import {
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
} from '@coreui/icons';
import * as Sentry from '@sentry/vue';
// router
import router from './router';
// store
import { createPinia } from 'pinia';
import piniaPluginPersiststate from 'pinia-plugin-persistedstate';
// v-calendar
import { setupCalendar } from 'v-calendar';
import veProgress from "vue-ellipse-progress";
const pinia = createPinia();
pinia.use(piniaPluginPersiststate);

const app = createApp(App);
const icons = {
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
};

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    // Vue 3 アプリのインスタンス
    app,

    // プロジェクト固有の DSN（Data Source Name）
    dsn: import.meta.env.VITE_SENTRY_DSN,

    // ヘッダ、クッキーデータを含めるかどうか
    sendDefaultPii: true,

    // 各種プラグイン（Integration）を列挙
    integrations: [
      // ルーター連携付き BrowserTracing
      Sentry.browserTracingIntegration({ router }),
      // セッションリプレイ
      Sentry.replayIntegration({
        // プライバシー保護のため、ユーザーの入力をマスク
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // トレースサンプリングレート
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '1.0'),

    // セッションリプレイのサンプリングレート
    replaysSessionSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SAMPLE_RATE || '1.0'),

    // エラー発生時のセッションリプレイのサンプリングレート
    replaysOnErrorSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0'),

    // 分散トレーシング対象 URL（fetch/XHR のヘッダー伝播先）
    tracePropagationTargets: ['localhost', /^\//],
  });
}

// @TODO: 不要になったら削除
// // テスト用コード
// // --- Sentry 動作確認用の意図的エラー -----------------
// // SDK が初期化されたあと 1 tick 遅らせて投げると、
// // Vue の初期描画が完了してから落ちるのでデータが取りこぼれにくい
// setTimeout(() => {
//   // @ts-ignore
//   myUndefinedFunction();
// });

app.use(router);
app.provide('icons', icons);
app.component('CIcon', CIcon);
app.use(pinia);
app.use(veProgress);
app.mount('#app');
app.use(setupCalendar, {})
